import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { IPayroll } from '../../interfaces/payroll.interface';

/** Salary-expense accrual status of a finalized payroll row (null for drafts). */
const PayrollAccrualChip: React.FC<{ payroll: Pick<IPayroll, 'accrualStatus' | 'accrualError'> }> = ({ payroll }) => {
    switch (payroll.accrualStatus) {
        case 'POSTED':
            return (
                <Tooltip title="Salary expense was recognised when this payroll was finalized; payment only clears Salaries Payable.">
                    <Chip label="Accrued" color="info" variant="outlined" size="small" />
                </Tooltip>
            );
        case 'NOT_POSTED':
            return (
                <Tooltip title={`${payroll.accrualError ?? ''} Payment will post the full expense instead.`}>
                    <Chip label="Accrual not posted" color="warning" variant="outlined" size="small" />
                </Tooltip>
            );
        case 'LEGACY':
            return (
                <Tooltip title="Finalized before payroll accruals existed; the expense is recognised at payment.">
                    <Chip label="Expensed at payment" variant="outlined" size="small" />
                </Tooltip>
            );
        default:
            return null;
    }
};

export default PayrollAccrualChip;
